import { useApi } from '@/api';
import { ChartSkeleton } from '@/components';
import {
  CurrencyValue,
  Flex,
  LineChart,
  formatNumber,
  formatPercentage
} from '@blockanalitica/ui';
import { ChartConfig } from '@blockanalitica/ui/package/types/src/components/charts/Chart';
import { useMemo } from 'react';

export default function CollateralAtRiskGraph({ ilk }: { ilk: string }) {
  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/at-risk/`
  });

  if (error) {
    throw error;
  }
  const valueFormatter = useMemo(() => {
    return function valueFormatter(value: string) {
      return (
        <CurrencyValue
          value={value.toString()}
          options={{
            currency: 'USD'
          }}
        />
      );
    };
  }, []);
  const xScaleValueFormatter = useMemo(() => {
    return (value: string) => {
      return formatPercentage(Number(value));
    };
  }, []);

  const yScaleValueFormatter = (value) => {
    return formatNumber(Number(value));
  };
  const subValueFormatter = useMemo(() => {
    return function subValueFormatter(value: string) {
      return <>Price Drop: {formatPercentage(Number(value))}</>;
    };
  }, []);
  const config: ChartConfig = useMemo(() => {
    return {
      type: 'line',
      options: {
        fill: true,
        elements: {
          line: {
            borderWidth: 2
          }
        },
        scales: {
          x: {
            type: 'linear',
            reverse: true
          }
        }
      }
    };
  }, []);
  const datasets = useMemo(() => {
    return [
      {
        xField: 'drop',
        yField: 'value',
        label: 'symbol'
      }
    ];
  }, []);

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        <LineChart
          data={data}
          valueFormatter={valueFormatter}
          datasets={datasets}
          defaultDataIndex={5}
          xScaleValueFormatter={xScaleValueFormatter}
          yScaleValueFormatter={yScaleValueFormatter}
          subValueFormatter={subValueFormatter}
          config={config}
        />
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
